import { subMonths, subYears } from 'date-fns';

export type ChartDuration = '3m' | '6m' | '1y' | 'all';

/** Start of the rolling window a duration selects, or null for the unbounded "all". */
export const getChartDurationCutoff = (duration: ChartDuration): Date | null => {
  const now = new Date();
  switch (duration) {
    case '3m':
      return subMonths(now, 3);
    case '6m':
      return subMonths(now, 6);
    case '1y':
      return subYears(now, 1);
    case 'all':
      return null;
    default:
      return null;
  }
};
